import React, { Component } from 'react'
// import { Connector } from "mqtt-react";
import { hot } from 'react-hot-loader'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import history from 'lib/history'
import configureStore from 'modules/configureStore'
import Layout from 'modules/ui/components/Layout'
import * as Sentry from '@sentry/react'
import { Button, Result } from 'antd'
import './styled/fix-line-lost.css'

// ไม่ใส่ fallback ให้ Sentry.ErrorBoundary = พอมี error มันจะ render null
// ผู้ใช้เห็นจอเปล่าสีพื้นหลัง ไม่รู้ว่าเกิดอะไรขึ้นและกดอะไรต่อไม่ได้
const ErrorFallback = ({ error, componentStack, resetError }) => (
  <Result
    status="500"
    title="เกิดข้อผิดพลาด"
    subTitle={
      <div>
        <div>ระบบทำงานผิดพลาดชั่วคราว ลองใหม่อีกครั้งหรือกลับไปหน้าแรก</div>
        <div className="app-error-detail">
          {error && (error.message || String(error))}
          {componentStack
            ? '\n' +
              componentStack
                .split('\n')
                .filter(line => line.trim())
                .slice(0, 5)
                .join('\n')
            : ''}
        </div>
      </div>
    }
    extra={[
      <Button type="primary" key="retry" onClick={resetError}>
        ลองใหม่
      </Button>,
      <Button key="home" onClick={() => window.location.replace('/')}>
        กลับหน้าแรก
      </Button>,
    ]}
  />
)

// เขียนลง console ด้วย — ต่อ Safari Web Inspector จากมือถือแล้วเห็น stack เต็ม
const logBoundaryError = (error, componentStack) => {
  console.error('[AppErrorBoundary]', error, componentStack)
}

const store = configureStore()

class App extends Component {
  render() {
    return (
      <Sentry.ErrorBoundary fallback={ErrorFallback} onError={logBoundaryError}>
        <Provider store={store}>
          <Router history={history}>
            <Layout />
          </Router>
        </Provider>
      </Sentry.ErrorBoundary>
    )
  }
}

export default hot(module)(App)
